import { call, cancel, fork, put, take, takeLatest } from "redux-saga/effects";
import * as types from "./CapacityvsDemandTableActionType";
import * as actions from "./CapacityvsDemandTableAction";
import * as services from "./CapacityvsDemandTableService";
import SweetAlert from "../../../components/sweetalert/SweetAlert";
import { downloadBase64File } from "../../../utils/fileDownloads";

//------Fetch Capacity vs Demand DD List Saga ----//
function* fetchCapacityReportDDList() {
  try {
    const response = yield call(services.fetchCapacityVSDemandDDList);

    if (response?.success) {
      yield put(actions.fetchCapacityDDListSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapacityDDListFailure("Failed to fetch dropdown list"),
      );
      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Capacity Report DD List Error:", error);

    yield put(
      actions.fetchCapacityDDListFailure(
        error?.message || "Failed to fetch dropdown list",
      ),
    );
    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Capacity Reports dropdown list.",
    });
  }
}

//-----Fetch Capacity vs Demand Report List saga---------//
function* fetchCapacityVsDemandSaga(action) {
  try {
    const response = yield call(
      services.fetchCapacityVSDemandReportData,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchCapsVsDemandReportSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapsVsDemandReportFailure("Failed to fetch report data"),
      );
      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Capacity Vs Demand Report Error:", error);

    yield put(actions.fetchCapsVsDemandReportFailure(error?.message));
    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//-------Fetch Legend Data---//
function* fetchLegendDataSaga(action) {
  try {
    const response = yield call(services.fetchLegendData, action.payload);

    if (response?.success) {
      yield put(actions.fetchLegendDataSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(actions.fetchLegendDataFailure("Failed to fetch legend data"));

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Legend Data Error:", error);

    yield put(
      actions.fetchLegendDataFailure(
        error?.message || "Failed to fetch legend data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: error?.message || "Failed to fetch legend data.",
    });
  }
}

//-------Fetch Available Shift Filter DDList---//
function* fetchAvailableShiftDDList(action) {
  try {
    const response = yield call(
      services.fectchAvailableFilterDDList,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchAvailableshiftFilterDDListSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(actions.fetchAvailableshiftFilterDDListFailure());
      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Available Shift DD List Error:", error);

    yield put(
      actions.fetchAvailableshiftFilterDDListFailure(
        error?.message || "Failed to fetch available shift dropdown list",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: error?.message || "Failed to fetch available shift dropdown list.",
    });
  }
}

//-------Fetch Worklist By Worklist Group DDList (cascading Worklist filter)---//
// Shared by the Capacity vs Demand and Available Shifts tabs -- payload.tabKey
// ("capVsDem" / "availableShifts") keeps each tab's list separate in the reducer.
function* fetchCapsWorklistByGroupDDListSaga(action) {
  const tabKey = action.payload?.tabKey;
  try {
    const response = yield call(
      services.fetchWorklistByWorklistGroupDDList,
      action.payload?.WorklistGroupIDs,
    );

    if (response?.success) {
      yield put(
        actions.fetchCapsWorklistByGroupDDListSuccess({
          tabKey,
          values: response?.values || [],
        }),
      );
    } else {
      yield put(
        actions.fetchCapsWorklistByGroupDDListFailure({
          tabKey,
          message: response?.errorMessage || "Failed to fetch worklist dropdown list",
        }),
      );
    }
  } catch (error) {
    console.error("Fetch Worklist By Worklist Group DD List Error:", error);
    yield put(
      actions.fetchCapsWorklistByGroupDDListFailure({
        tabKey,
        message: error?.message || "Failed to fetch worklist dropdown list",
      }),
    );
  }
}

//-------Fetch Available Shift Data---//
function* fetchAvailableShiftDataSaga(action) {
  try {
    const response = yield call(
      services.fecthAvailabeshiftData,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fectchAvailableShiftSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fectchAvailableShiftFailure(
          "Failed to fetch Available Shift data",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Available Shift Data Error:", error);

    yield put(
      actions.fectchAvailableShiftFailure(
        error?.message || "Failed to fetch Available Shift data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Available Shift data.",
    });
  }
}

//-------Fetch Available Shift RPCE Data---//
function* fetchAvailableShiftRPCESaga(action) {
  try {
    const response = yield call(
      services.fetchAvailableShiftData,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchAvailableShiftRPCESuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchAvailableShiftRPCEFailure(
          "Failed to fetch available shift data",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Available Shift RPCE Error:", error);

    yield put(
      actions.fetchAvailableShiftRPCEFailure(
        error?.message || "Failed to fetch available shift data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//-----Fetch Available Shift Worklist Data---------//
function* fetchAvailableShiftWorklistSaga(action) {
  try {
    const response = yield call(
      services.fetchAvailableShiftWorklist,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchAvailableShiftWorklistSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchAvailableShiftWorklistFailure(
          "Failed to fetch worklist data",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Available Shift Worklist Error:", error);

    yield put(
      actions.fetchAvailableShiftWorklistFailure(
        error?.message || "Failed to fetch worklist data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//-------Fetch RPCE DATA in CspVsDemand tab---//
function* fetchCapsVsDemandRPCESaga(action) {
  try {
    const response = yield call(
      services.fetchCapsVsDemandShiftRPCE,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchCapsVsDemandShiftRPCESuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapsVsDemandShiftRPCEFailure(
          "Failed to fetch report data",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Caps Vs Demand RPCE Error:", error);

    yield put(
      actions.fetchCapsVsDemandShiftRPCEFailure(
        error?.message || "Failed to fetch report data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//-------Fetch Worklist DATA in CspVsDemand tab---//
function* fetchCapsVsDemandWorklistSaga(action) {
  try {
    const response = yield call(
      services.fetchCapsVsDemandShiftWorklist,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchCapsVsDemandShiftWorklistSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapsVsDemandShiftWorklistFailure(
          "Failed to fetch worklist data",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Caps Vs Demand Worklist Error:", error);

    yield put(
      actions.fetchCapsVsDemandShiftWorklistFailure(
        error?.message || "Failed to fetch worklist data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//--------Fetch Capacity Details in CapsVsDemand tab on popup---//
function* fetchCapacityDetailsSaga(action) {
  try {
    const response = yield call(
      services.fetchCapacityPopupDetails,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchCapacityPopupDetailsSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapacityPopupDetailsFailure(
          "Failed to fetch capacity details",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Capacity Details Error:", error);

    yield put(
      actions.fetchCapacityPopupDetailsFailure(
        error?.message || "Failed to fetch capacity details",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//--------Fetch Worklist Details in CapsVsDemand tab on popup---//
function* fetchWorklistDetailsSaga(action) {
  try {
    const response = yield call(
      services.fetchWorklistDetailsData,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchWorklistDetailSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchWorklistDetailFailure("Failed to fetch worklist details"),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Worklist Details Error:", error);

    yield put(
      actions.fetchWorklistDetailFailure(
        error?.message || "Failed to fetch worklist details",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//-------Fetch Capacity Vs Demand Get By Id Details---//
function* fetchCapacityVsDemandDetailsByIdSaga(action) {
  try {
    const response = yield call(
      services.fetchCapacityVsDemandDetailsById,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchCapsVsDemandDetailsByIdSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapsVsDemandDetailsByIdFailure(
          "Failed to fetch report details",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Capacity Vs Demand Details By Id Error:", error);

    yield put(
      actions.fetchCapsVsDemandDetailsByIdFailure(
        error?.message || "Failed to fetch report details",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//-------Fetch Notes Details in CapsVsDemand ---//
function* fetchNotesDetailsByIdSaga(action) {
  try {
    const response = yield call(services.fetchNotesDetails, action.payload);

    if (response?.success) {
      yield put(actions.fetchCapsVsdemandNotesDetailsSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapsVsdemandNotesDetailsFailure(
          "Failed to fetch notes details",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Notes Details Error:", error);

    yield put(
      actions.fetchCapsVsdemandNotesDetailsFailure(
        error?.message || "Failed to fetch notes details",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports notes data.",
    });
  }
}

//-------Save Notes Details in CapsVsDemand ---//
function* SaveCapsVsDemandNotesSaga(action) {
  try {
    const response = yield call(services.saveNotesRequest, action.payload);

    if (response?.success) {
      yield put(actions.saveCapsVsDemandNotesSuccess(response));

      yield put(
        actions.fetchCapsVsDemandReportRequest({
          SkipNoOfRecords: 0,
          PageSize: 100,
          sSearch: "",
          sortColumn: "CapacityVsDemandTableID",
          sortColumnDir: "desc",
        }),
      );

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });
    } else {
      yield put(actions.saveCapsVsDemandNotesFailure("Failed to save notes"));

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Save Caps Vs Demand Notes Error:", error);

    yield put(
      actions.saveCapsVsDemandNotesFailure(
        error?.message || "Failed to save notes",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to save notes.",
    });
  }
}

//-------Publish Capacity vs Demand Report---//
function* publishCapsVsDemandSaga(action) {
  try {
    const response = yield call(
      services.PublishCapsVsDemandReport,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.PublishCapsVsDemandSuccess(response));

      const payload = {
        SkipNoOfRecords: 0,
        PageSize: 100,
        sSearch: "",
        sortColumn: "CapacityVsDemandTableID",
        sortColumnDir: "desc",
      };
      yield put(actions.fetchCapsVsDemandReportRequest(payload));

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });
    } else {
      yield put(
        actions.PublishCapsVsDemandFailure({
          Message: response?.errorMessage || "Failed to publish report",
        }),
      );
      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Publish Capacity Vs Demand Error:", error);
    yield put(
      actions.PublishCapsVsDemandFailure({
        Message: error?.message || "Failed to publish report",
      }),
    );
    SweetAlert.error({
      title: "Error!",
      text: error?.message || "Failed to publish report.",
    });
  }
}

//----------Export on RPCE data in Available shift---//
function* exportRPCEDataReportSaga(action) {
  try {
    const { CapacityVsDemandTableID, fileName } = action.payload;

    const response = yield call(
      services.exportRPCEDataRequest,
      CapacityVsDemandTableID,
    );

    if (response?.success) {
      const base64Data = response?.values || response?.data || response;

      if (!base64Data) {
        yield put(
          actions.exportRPCEDataAvailableShiftFailure("No export data found"),
        );

        SweetAlert.error({
          title: "Error!",
          text: "No data available to export.",
        });
        return;
      }

      yield call(downloadBase64File, base64Data, fileName);

      yield put(actions.exportRPCEDataAvailableShiftSuccess());

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });
    } else {
      yield put(actions.exportRPCEDataAvailableShiftFailure("Export failed"));

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Export RPCE Data Error:", error);

    yield put(
      actions.exportRPCEDataAvailableShiftFailure(
        error?.message || "Export failed",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to export Capacity vs Demand Available Shifts RPCE Data.",
    });
  }
}

//----------Export on Worklist data in Available shift---//
function* exportWorklistDataReportSaga(action) {
  try {
    const { CapacityVsDemandTableID, fileName } = action.payload;

    const response = yield call(
      services.exportWorklistRequest,
      CapacityVsDemandTableID,
    );

    if (response?.success) {
      const base64Data = response?.values || response?.data || response;

      if (!base64Data) {
        throw new Error("No file data received");
      }

      yield call(downloadBase64File, base64Data, fileName);

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });

      yield put(actions.exportWorklistDataAvailableShiftSuccess());
    } else {
      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });

      yield put(
        actions.exportWorklistDataAvailableShiftFailure(
          response?.errorMessage || "Export failed",
        ),
      );
    }
  } catch (error) {
    console.error("Export Worklist Data Error:", error);

    SweetAlert.error({
      title: "Error!",
      text:
        error?.message ||
        "Failed to export Capacity vs Demand Available Shifts data.",
    });

    yield put(
      actions.exportWorklistDataAvailableShiftFailure(
        error?.message || "Export failed",
      ),
    );
  }
}

//----------Export RPCE Data in Caps Vs Demnad tab---//
function* exportRPCEDataCapsVsDemandReportSaga(action) {
  try {
    const { CapacityVsDemandTableID, fileName } = action.payload;

    const response = yield call(
      services.exportRPCEDataCapsVsDemand,
      CapacityVsDemandTableID,
    );

    if (response?.success) {
      const base64Data = response?.values || response?.data;

      if (!base64Data) {
        throw new Error("No export data received");
      }

      yield call(downloadBase64File, base64Data, fileName);

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });

      yield put(actions.exportRPCECapsVsDemandSuccess());
    } else {
      yield put(actions.exportRPCECapsVsDemandFailure("Export failed"));

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Export RPCE Capacity Vs Demand Error:", error);

    yield put(
      actions.exportRPCECapsVsDemandFailure(error?.message || "Export failed"),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to export Capacity vs Demand RPCE data.",
    });
  }
}

//----------Export Worklist Data in Caps Vs Demnad tab---//
function* exportWorklistDataCapsVsDemandSaga(action) {
  try {
    const { CapacityVsDemandTableID, fileName } = action.payload;

    const response = yield call(
      services.exportWorklistCapsVsDemandRequest,
      CapacityVsDemandTableID,
    );

    if (response?.success) {
      const base64Data = response?.values || response?.data || response;

      if (base64Data) {
        yield call(downloadBase64File, base64Data, fileName);
      }

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });

      yield put(actions.exportWorklistCapsVsDemandSuccess());
    } else {
      yield put(
        actions.exportWorklistCapsVsDemandFailure("Failed to export data"),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Export Capacity Vs Demand Error:", error);

    yield put(
      actions.exportWorklistCapsVsDemandFailure(
        error?.message || "Failed to export data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to export Capacity vs Demand Table Data.",
    });
  }
}

//-------Delete Capacity vs Demand Report---//
function* deleteCapsVsDemandSaga(action) {
  try {
    const { CapsVsdemandid } = action.payload;
    const response = yield call(
      services.deleteCapsVsdemandRequest,
      CapsVsdemandid,
    );

    if (response?.success) {
      yield put(actions.deleteCapsVsDemandSuccess(CapsVsdemandid));

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });

      yield put(
        actions.fetchCapsVsDemandReportRequest({
          SkipNoOfRecords: 0,
          PageSize: 100,
          sSearch: "",
          sortColumn: "CapacityVsDemandTableID",
          sortColumnDir: "desc",
        }),
      );
    } else {
      yield put(actions.deleteCapsVsDemandFailure("Failed to delete report"));

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Delete Capacity Vs Demand Report Error:", error);

    // Dispatch failure action
    yield put(
      actions.deleteCapsVsDemandFailure(
        error?.message || "Failed to delete report",
      ),
    );

    // Show error notification
    SweetAlert.error({
      title: "Error!",
      text: "Failed to delete Capacity Vs Demand report.",
    });
  }
}

//--------Export Capacity vs Demand Report---//
function* exportCapsVsDemandReportSaga(action) {
  try {
    const { CapacityVsDemandTableID, fileName } = action.payload;

    const response = yield call(
      services.exportCapacityVsDemandReport,
      CapacityVsDemandTableID,
    );

    if (response?.success) {
      const base64Data = response?.values || response;
      if (base64Data) {
        yield call(downloadBase64File, base64Data, fileName);
      }

      yield put(actions.exportCapsVsDemandReportSuccess());

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });
    } else {
      yield put(
        actions.exportCapsVsDemandReportFailure("Failed to export report"),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Export Capacity Vs Demand Report Error:", error);

    yield put(
      actions.exportCapsVsDemandReportFailure(
        error?.message || "Failed to export report",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to export Capacity vs Demand report.",
    });
  }
}

//-------Generate Capacity Vs Demand Report (Encore)---//
function* generateCapsVsDemandReportEncoreSaga(action) {
  try {
    const response = yield call(
      services.generateCapacityVsDemandReportEncore,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.generateCapsVsDemandReportEncoreSuccess(response));
    } else {
      yield put(
        actions.generateCapsVsDemandReportEncoreFailure(
          "Failed to generate Capacity vs Demand report",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Generate Capacity Vs Demand Report Encore Error:", error);

    yield put(
      actions.generateCapsVsDemandReportEncoreFailure(
        error?.message || "Failed to generate Capacity vs Demand report",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to generate Capacity vs Demand report.",
    });
  }
}

//-------Fetch Capacity Vs Demand Tab Details With Pagination (Encore)---//
function* fetchCapsVsDemandTabDetailsEncoreSaga(action) {
  try {
    const response = yield call(
      services.fetchCapacityVsDemandTabDetailsEncore,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchCapsVsDemandTabDetailsEncoreSuccess(response));
    } else {
      yield put(
        actions.fetchCapsVsDemandTabDetailsEncoreFailure(
          "Failed to fetch Capacity vs Demand tab details",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Capacity Vs Demand Tab Details Encore Error:", error);

    yield put(
      actions.fetchCapsVsDemandTabDetailsEncoreFailure(
        error?.message || "Failed to fetch Capacity vs Demand tab details",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Capacity vs Demand tab details.",
    });
  }
}

//-------Fetch Access To Demand Details With Pagination (hour cell popup)---//
function* fetchAccessToDemandSaga(action) {
  try {
    const response = yield call(services.fetchAccessToDemandDetails, action.payload);

    // Unlike every other endpoint in this file (which camelCase via ASP.NET Web API's
    // default JsonMediaTypeFormatter), this specific endpoint's response is genuinely
    // PascalCase -- confirmed twice via live testing (a captured browser response, and
    // this exact regression reappearing when this fix was reverted). Root cause of the
    // inconsistency not yet identified; do not "fix" this back to lowercase without
    // re-verifying live first.
    if (response?.Success) {
      yield put(actions.fetchAccessToDemandSuccess(response));
    } else {
      yield put(
        actions.fetchAccessToDemandFailure("Failed to fetch Access to Demand details"),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.ErrorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Access To Demand Error:", error);

    yield put(
      actions.fetchAccessToDemandFailure(
        error?.message || "Failed to fetch Access to Demand details",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Access to Demand details.",
    });
  }
}

//-------Fetch Available Shifts Tab Details With Pagination (Encore)---//
function* fetchAvailableShiftsTabDetailsEncoreSaga(action) {
  try {
    const response = yield call(
      services.fetchAvailableShiftsTabDetailsEncore,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchAvailableShiftsTabDetailsEncoreSuccess(response));
    } else {
      yield put(
        actions.fetchAvailableShiftsTabDetailsEncoreFailure(
          "Failed to fetch Available Shifts tab details",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Available Shifts Tab Details Encore Error:", error);

    yield put(
      actions.fetchAvailableShiftsTabDetailsEncoreFailure(
        error?.message || "Failed to fetch Available Shifts tab details",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Available Shifts tab details.",
    });
  }
}

//-------Export Capacity Vs Demand Report (Encore)---//
function* exportCapsVsDemandReportEncoreSaga(action) {
  try {
    const { fileName, ...requestPayload } = action.payload;
    const response = yield call(
      services.exportCapacityVsDemandReportEncore,
      requestPayload,
    );

    if (response?.success) {
      const base64Data = response?.values;

      if (!base64Data) {
        yield put(
          actions.exportCapsVsDemandReportEncoreFailure("No export data found"),
        );

        SweetAlert.error({
          title: "Error!",
          text: "No data available to export.",
        });
        return;
      }

      yield call(downloadBase64File, base64Data, fileName);

      yield put(actions.exportCapsVsDemandReportEncoreSuccess());

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });
    } else {
      yield put(
        actions.exportCapsVsDemandReportEncoreFailure("Failed to export report"),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Export Capacity Vs Demand Report Encore Error:", error);

    yield put(
      actions.exportCapsVsDemandReportEncoreFailure(
        error?.message || "Failed to export report",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to export Capacity vs Demand report.",
    });
  }
}

//-------Delete Capacity Vs Demand Report (Encore)---//
function* deleteCapsVsDemandEncoreSaga(action) {
  try {
    const { CapacityVsDemandTableID } = action.payload;
    const response = yield call(
      services.deleteCapsVsdemandEncoreRequest,
      CapacityVsDemandTableID,
    );

    if (response?.success) {
      yield put(actions.deleteCapsVsDemandEncoreSuccess(response));

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });

      yield put(
        actions.fetchCapsVsDemandReportRequest({
          SkipNoOfRecords: 0,
          PageSize: 100,
          sSearch: "",
          sortColumn: "CapacityVsDemandTableID",
          sortColumnDir: "desc",
        }),
      );
    } else {
      yield put(
        actions.deleteCapsVsDemandEncoreFailure("Failed to delete report"),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Delete Capacity Vs Demand Report Encore Error:", error);

    yield put(
      actions.deleteCapsVsDemandEncoreFailure(
        error?.message || "Failed to delete report",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to delete Capacity Vs Demand report.",
    });
  }
}

//-------Publish Capacity Vs Demand Report (Encore)---//
function* publishCapsVsDemandEncoreSaga(action) {
  try {
    const response = yield call(
      services.publishCapacityVsDemandReportEncore,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.publishCapsVsDemandEncoreSuccess(response));

      yield put(
        actions.fetchCapsVsDemandReportRequest({
          SkipNoOfRecords: 0,
          PageSize: 100,
          sSearch: "",
          sortColumn: "CapacityVsDemandTableID",
          sortColumnDir: "desc",
        }),
      );

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });
    } else {
      yield put(
        actions.publishCapsVsDemandEncoreFailure({
          Message: response?.errorMessage || "Failed to publish report",
        }),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Publish Capacity Vs Demand Report Encore Error:", error);

    yield put(
      actions.publishCapsVsDemandEncoreFailure({
        Message: error?.message || "Failed to publish report",
      }),
    );

    SweetAlert.error({
      title: "Error!",
      text: error?.message || "Failed to publish report.",
    });
  }
}

// Latest-wins per tab: the Capacity vs Demand and Available Shifts tabs share this action, so a
// plain takeLatest would let one tab's request cancel the other's (leaving its Worklist dropdown
// stuck loading). Results are already stored per tabKey.
function* watchCapsWorklistByGroupPerTab() {
  const tasks = {};
  while (true) {
    const action = yield take(types.FETCH_CAPS_WORKLIST_BY_GROUP_DD_REQUEST);
    const tabKey = action.payload?.tabKey ?? "default";
    if (tasks[tabKey]?.isRunning()) {
      yield cancel(tasks[tabKey]);
    }
    tasks[tabKey] = yield fork(fetchCapsWorklistByGroupDDListSaga, action);
  }
}

function* watchCapsvsDemandSaga() {
  yield takeLatest(
    types.FETCH_CAPACITY_REPORT_DDLIST_REQUEST,
    fetchCapacityReportDDList,
  );
  yield takeLatest(
    types.FETCH_CAPACITYVsDEMAND_REPORT_REQUEST,
    fetchCapacityVsDemandSaga,
  );
  yield takeLatest(
    types.EXPORT_CAPSVSDEMAND_REPORT_REQUEST,
    exportCapsVsDemandReportSaga,
  );
  yield takeLatest(
    types.FETCH_AVAILABLE_SHIFT_REQUEST,
    fetchAvailableShiftDataSaga,
  );
  yield takeLatest(
    types.FETCH_AVAILABLE_SHIFT_RPCE_REQUEST,
    fetchAvailableShiftRPCESaga,
  );
  yield takeLatest(
    types.FETCH_AVAILABLE_SHIFT_FILTERDDLIST_REQUEST,
    fetchAvailableShiftDDList,
  );
  yield takeLatest(
    types.FETCH_AVAILABLESHIFT_LEGEND_REQUEST,
    fetchLegendDataSaga,
  );
  yield takeLatest(
    types.FETCH_AVAILABLE_WORKLISTDATA_REQUEST,
    fetchAvailableShiftWorklistSaga,
  );
  yield takeLatest(
    types.FETCH_RPCE_DATA_CAPSVSDEMAND_REQUEST,
    fetchCapsVsDemandRPCESaga,
  );
  yield takeLatest(
    types.FETCH_WORKLIST_DATA_CAPSVSDEMAND_REQUEST,
    fetchCapsVsDemandWorklistSaga,
  );
  yield takeLatest(
    types.DELETE_CAPSVSDEMAND_REPORT_REQUEST,
    deleteCapsVsDemandSaga,
  );
  yield takeLatest(
    types.FETCH_CAPACITY_HOVER_DETAILS_REQUEST,
    fetchCapacityDetailsSaga,
  );
  yield takeLatest(
    types.FETCH_WORKLIST_HOVER_DETAILS_REQUEST,
    fetchWorklistDetailsSaga,
  );
  yield takeLatest(
    types.FETCH_GETBY_ID_DETAILS_REQUEST,
    fetchCapacityVsDemandDetailsByIdSaga,
  );
  yield takeLatest(
    types.FETCH_CAPSVSDEMAND_NOTES_DETAILS_REQUEST,
    fetchNotesDetailsByIdSaga,
  );
  yield takeLatest(
    types.SAVE_CAPSVSDEMAND_NOTES_REQUEST,
    SaveCapsVsDemandNotesSaga,
  );
  yield takeLatest(
    types.PUBLISH_CAPSVSDEMAND_REPORT_REQUEST,
    publishCapsVsDemandSaga,
  );
  yield takeLatest(
    types.EXPORT_RPCE_DATA_AVAILABLESHIFT_REQUEST,
    exportRPCEDataReportSaga,
  );
  yield takeLatest(
    types.EXPORT_WORKLIST_DATA_AVAILABLESHIFT_REQUEST,
    exportWorklistDataReportSaga,
  );
  yield takeLatest(
    types.EXPORT_RPCE_CAPSVSDEMAND_REQUEST,
    exportRPCEDataCapsVsDemandReportSaga,
  );
  yield takeLatest(
    types.EXPORT_WORKLIST_CAPSVSDEMAND_REQUEST,
    exportWorklistDataCapsVsDemandSaga,
  );
  yield takeLatest(
    types.GENERATE_CAPSVSDEMAND_REPORT_ENCORE_REQUEST,
    generateCapsVsDemandReportEncoreSaga,
  );
  yield takeLatest(
    types.FETCH_CAPSVSDEMAND_TABDETAILS_ENCORE_REQUEST,
    fetchCapsVsDemandTabDetailsEncoreSaga,
  );
  yield takeLatest(
    types.FETCH_AVAILABLESHIFTS_TABDETAILS_ENCORE_REQUEST,
    fetchAvailableShiftsTabDetailsEncoreSaga,
  );
  yield takeLatest(
    types.FETCH_ACCESS_TO_DEMAND_REQUEST,
    fetchAccessToDemandSaga,
  );
  yield takeLatest(
    types.EXPORT_CAPSVSDEMAND_REPORT_ENCORE_REQUEST,
    exportCapsVsDemandReportEncoreSaga,
  );
  yield takeLatest(
    types.DELETE_CAPSVSDEMAND_REPORT_ENCORE_REQUEST,
    deleteCapsVsDemandEncoreSaga,
  );
  yield takeLatest(
    types.PUBLISH_CAPSVSDEMAND_REPORT_ENCORE_REQUEST,
    publishCapsVsDemandEncoreSaga,
  );
  yield fork(watchCapsWorklistByGroupPerTab);
}

export default watchCapsvsDemandSaga;
